var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
import { localStorageStore } from "@cxp-shared/caching";
import { FetchClient } from "@cxp-shared/fetch-client";
import { Service } from "@cxp-shared/platform/Service";
import { CommonDataServiceName } from "@cxp-shared/services/CDS";
import { PerformanceServiceName } from "@cxp-shared/services/Performance";
import { SegmentServiceName } from "@cxp-shared/services/Segments";
import { brandLogicalName, cjoMetadataItems, eventsByName, legalMetadataItems, tableMetadataItems, unsupporteBrandAttributeLogicalNames, unsupporteBrandAttributeType } from "./MetadataConstants";
import { metadataItemCRMToMetadataItem } from "./MetadataEntityCRMUtils";
import { batchEventNames, buildEventNamesUrl } from "./DataSources/MetadataStoreEventDataSourceUtils";
import { batchDataverseSourceLogicalNames, buildDisplayNameUrl, buildUrlForAllEntityMetadata, defaultDatasetConfiguration, extractDisplayName } from "./DataSources/MetadataStoreDataverseDataSourceUtils";
import { FeatureFlagsServiceName } from "@cxp-shared/feature-flags";
import { EntityPrivilegeFilterServiceName } from "@cxp-shared/services/EntityPrivilegeFilter";
import { TelemetryServiceName } from "@cxp-shared/services/Telemetry";
var MetadataStoreService = /** @class */ (function (_super) {
    __extends(MetadataStoreService, _super);
    function MetadataStoreService(crmUrl, perfService, segmentService) {
        var _this = _super.call(this) || this;
        _this.crmUrl = crmUrl;
        _this.perfService = perfService;
        _this.segmentService = segmentService;
        localStorageStore.init();
        return _this;
    }
    MetadataStoreService.prototype.serviceStart = function (appContext) {
        _super.prototype.serviceStart.call(this, appContext);
        if (!this.perfService) {
            this.perfService = appContext.getService(PerformanceServiceName);
        }
        if (!this.segmentService) {
            this.segmentService = appContext.getService(SegmentServiceName);
        }
        try {
            this.featureFlagsService = appContext.getService(FeatureFlagsServiceName);
            this.entityPrivilegeFilterService = appContext.getService(EntityPrivilegeFilterServiceName);
        }
        catch (error) {
            // Nothing to do, for the LSAC thing I need to make sure if we forgot to propagate this somewhere it does not crash
        }
        this.commonDataService = appContext.getService(CommonDataServiceName);
        this.telemetryService = this.appContext.getService(TelemetryServiceName);
    };
    MetadataStoreService.prototype.getDisplayNames = function (sourceLogicalNames) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var perfEvent, logicalNames, query, rawResult, result, retValue;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getDisplayNames-Ms");
                        logicalNames = Array.isArray(sourceLogicalNames) ? sourceLogicalNames : [sourceLogicalNames];
                        query = buildDisplayNameUrl(this.crmUrl, logicalNames);
                        return [4 /*yield*/, MetadataStoreService.fetchClient.fetchGet(query)];
                    case 1:
                        rawResult = _b.sent();
                        if (!rawResult.ok) {
                            throw new Error("Failed to get display names.");
                        }
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _b.sent();
                        retValue = {};
                        result.value.forEach(function (x) { return (retValue[x.LogicalName] = extractDisplayName(x.LogicalName, x.DisplayName)); });
                        return [2 /*return*/, retValue];
                }
            });
        });
    };
    MetadataStoreService.prototype.getEntityMetadataFromCRM = function (sourceLogicalNames) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var perfEvent, logicalNames, query, rawResult, result, retValue;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getDisplayNamesWithOwnership-Ms");
                        logicalNames = Array.isArray(sourceLogicalNames) ? sourceLogicalNames : [sourceLogicalNames];
                        query = buildDisplayNameUrl(this.crmUrl, logicalNames);
                        return [4 /*yield*/, MetadataStoreService.fetchClient.fetchGet(query)];
                    case 1:
                        rawResult = _b.sent();
                        if (!rawResult.ok) {
                            throw new Error("Failed to get display names.");
                        }
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _b.sent();
                        retValue = {};
                        result.value.forEach(function (x) {
                            return (retValue[x.LogicalName] = {
                                DisplayName: extractDisplayName(x.LogicalName, x.DisplayName),
                                LogicalName: x.LogicalName,
                                OwnershipType: x.OwnershipType
                            });
                        });
                        return [2 /*return*/, retValue];
                }
            });
        });
    };
    MetadataStoreService.prototype.getAllMetadataEntities = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var perfEvent, query, rawResult, result, retValue;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getAllMetadataEntities-Ms");
                        query = buildUrlForAllEntityMetadata(this.crmUrl);
                        return [4 /*yield*/, MetadataStoreService.fetchClient.fetchGet(query)];
                    case 1:
                        rawResult = _b.sent();
                        if (!rawResult.ok) {
                            throw new Error("Failed to get display names.");
                        }
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _b.sent();
                        retValue = {};
                        result.value.forEach(function (x) { return (retValue[x.LogicalName] = extractDisplayName(x.LogicalName, x.DisplayName)); });
                        return [2 /*return*/, retValue];
                }
            });
        });
    };
    MetadataStoreService.prototype.getAllCjoEventsNames = function (includeDraftEvents, businessUnit, allowStaleData, isDoubleOptIn) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var perfEvent, url, rawResult, result;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getEventNames-Ms");
                        url = buildEventNamesUrl(this.crmUrl, includeDraftEvents, isDoubleOptIn);
                        return [4 /*yield*/, MetadataStoreService.fetchClient.fetchGet(url)];
                    case 1:
                        rawResult = _b.sent();
                        if (!rawResult.ok) {
                            throw new Error("Failed to get CjoEventsNames items.");
                        }
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, {
                                "@odata.context": result["@odata.context"],
                                value: result.value.map(function (k) { return _this.crmEventMetadataToBasicEventMetadata(k); }).map(function (m) { return _this.fillCIForEmptyAudience(m); })
                            }];
                }
            });
        });
    };
    MetadataStoreService.prototype.getSpecificSegments = function (ids) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var idsArray, perfEvent, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        idsArray = Array.isArray(ids) ? ids : [ids];
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getSpecificSegments-Perf-Ms");
                        return [4 /*yield*/, this.segmentService.getSpecificSegmentsAsync(idsArray, true)];
                    case 1:
                        result = _b.sent();
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [2 /*return*/, result];
                }
            });
        });
    };
    MetadataStoreService.prototype.getDatasetConfiguration = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var perfEvent, datasetConfig;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getDatasetConfiguration-Perf-Ms");
                        return [4 /*yield*/, this.getDisplayNames(defaultDatasetConfiguration)];
                    case 1:
                        datasetConfig = _b.sent();
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [2 /*return*/, Object.keys(datasetConfig).map(function (logicalName) {
                                return {
                                    sourceDisplayName: datasetConfig[logicalName],
                                    sourceLogicalName: logicalName
                                };
                            })];
                }
            });
        });
    };
    MetadataStoreService.prototype.getDataverseTableMetadataItems = function (sourceLogicalNames, useLazyRelatedEntitiesLoading) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, sourceLogicalNamesArray, perfEvent, batchedDataverseNames, retValuePromises, resolvedPromises, oDataContextValue, retValue, i, result, metadataItems, ffEnabled, checkPrivileges_1, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "".concat(this.crmUrl).concat(tableMetadataItems);
                        sourceLogicalNamesArray = Array.isArray(sourceLogicalNames) ? sourceLogicalNames : [sourceLogicalNames];
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getDataverseTableMetadataItems-Perf-Ms");
                        batchedDataverseNames = batchDataverseSourceLogicalNames(sourceLogicalNamesArray);
                        retValuePromises = batchedDataverseNames.map(function (x) {
                            if (useLazyRelatedEntitiesLoading != undefined) {
                                return MetadataStoreService.fetchClient.fetchPost(url, {
                                    msdynmkt_GetDataverseTableMetadataItems_request_SourceLogicalNames: x,
                                    msdynmkt_GetDataverseTableMetadataItems_request_UseLazyLoading: useLazyRelatedEntitiesLoading
                                });
                            }
                            else {
                                return MetadataStoreService.fetchClient.fetchPost(url, {
                                    msdynmkt_GetDataverseTableMetadataItems_request_SourceLogicalNames: x
                                });
                            }
                        });
                        return [4 /*yield*/, Promise.all(retValuePromises)];
                    case 1:
                        resolvedPromises = _b.sent();
                        oDataContextValue = "";
                        retValue = [];
                        i = 0;
                        _b.label = 2;
                    case 2:
                        if (!(i < resolvedPromises.length)) return [3 /*break*/, 5];
                        if (!resolvedPromises[i].ok) {
                            throw new Error("Failed to get Dataverse Metadata items.");
                        }
                        return [4 /*yield*/, resolvedPromises[i].json()];
                    case 3:
                        result = _b.sent();
                        metadataItems = result.value.map(function (k) { return metadataItemCRMToMetadataItem(k); });
                        retValue.push.apply(retValue, __spreadArray([], __read(metadataItems), false));
                        oDataContextValue = result["@odata.context"];
                        _b.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5:
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 10, , 11]);
                        return [4 /*yield*/, this.featureFlagsService.isFeatureEnabledAsync("msdynmkt_20221215_MetadataPrivilegeFilter", false)];
                    case 7:
                        ffEnabled = _b.sent();
                        if (!ffEnabled) return [3 /*break*/, 9];
                        return [4 /*yield*/, this.entityPrivilegeFilterService.getEntityPrivilegeFilter()];
                    case 8:
                        checkPrivileges_1 = _b.sent();
                        retValue = retValue.filter(function (m) {
                            var targetEntityLogicalName = Object.keys(m.referencedSources || {})[0];
                            if (targetEntityLogicalName &&
                                (m.dataType === "lookup" || m.dataType === "manyToManyRelationship" || m.dataType === "oneToManyRelationship")) {
                                var show = checkPrivileges_1(targetEntityLogicalName);
                                return show;
                            }
                            return true;
                        });
                        _b.label = 9;
                    case 9: return [3 /*break*/, 11];
                    case 10:
                        error_1 = _b.sent();
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/, {
                            "@odata.context": oDataContextValue,
                            value: retValue
                        }];
                }
            });
        });
    };
    MetadataStoreService.prototype.getBrandMetadataItems = function (useLazyRelatedEntitiesLoading) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, perfEvent, rawResult, result, items;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "".concat(this.crmUrl).concat(tableMetadataItems);
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getBrandMetadataItems-Perf-Ms");
                        return [4 /*yield*/, MetadataStoreService.fetchClient.fetchPost(url, {
                                msdynmkt_GetDataverseTableMetadataItems_request_SourceLogicalNames: [brandLogicalName],
                                msdynmkt_GetDataverseTableMetadataItems_request_UseLazyLoading: useLazyRelatedEntitiesLoading
                            })];
                    case 1:
                        rawResult = _b.sent();
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        if (!rawResult.ok) {
                            throw new Error("Failed to get Brand Metadata items.");
                        }
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _b.sent();
                        items = result.value
                            .map(function (k) { return metadataItemCRMToMetadataItem(k); })
                            .filter(function (item) { return !unsupporteBrandAttributeLogicalNames.has(item.logicalName) && !unsupporteBrandAttributeType.has(item.dataType); });
                        return [2 /*return*/, {
                                "@odata.context": result["@odata.context"],
                                value: items
                            }];
                }
            });
        });
    };
    MetadataStoreService.prototype.getAllCjoEventsMetadataItems = function (sourceLogicalNames) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, perfEvent, rawResult, result;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "".concat(this.crmUrl).concat(cjoMetadataItems);
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getAllCjoEventsMetadataItems-Perf-Ms");
                        return [4 /*yield*/, MetadataStoreService.fetchClient.fetchPost(url, "")];
                    case 1:
                        rawResult = _b.sent();
                        if (!rawResult.ok) {
                            throw new Error("Failed to get CjoMetadata items.");
                        }
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, {
                                "@odata.context": result["@odata.context"],
                                value: result.value.map(function (k) { return metadataItemCRMToMetadataItem(k); }).map(function (m) { return _this.fillCIForEmptyAudience(m); })
                            }];
                }
            });
        });
    };
    MetadataStoreService.prototype.getCjoEventsByName = function (eventNames) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, eventNamesArray, perfEvent, batchedEventNames, retValuePromises, resolvedPromises, oDataContextValue, retValue, i, result, metadataItems;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "".concat(this.crmUrl).concat(eventsByName);
                        eventNamesArray = Array.isArray(eventNames) ? eventNames : [eventNames];
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getCjoEventsByName-Perf-Ms");
                        batchedEventNames = batchEventNames(eventNamesArray);
                        retValuePromises = batchedEventNames.map(function (x) {
                            return MetadataStoreService.fetchClient.fetchPost(url, {
                                msdynmkt_GetCjoEventsMetadataItemsByNames_request_EventNames: x
                            });
                        });
                        return [4 /*yield*/, Promise.all(retValuePromises)];
                    case 1:
                        resolvedPromises = _b.sent();
                        oDataContextValue = "";
                        retValue = [];
                        i = 0;
                        _b.label = 2;
                    case 2:
                        if (!(i < resolvedPromises.length)) return [3 /*break*/, 5];
                        if (!resolvedPromises[i].ok) {
                            throw new Error("Failed to get Events by name Metadata items.");
                        }
                        return [4 /*yield*/, resolvedPromises[i].json()];
                    case 3:
                        result = _b.sent();
                        metadataItems = result.value.map(function (k) { return metadataItemCRMToMetadataItem(k); }).map(function (m) { return _this.fillCIForEmptyAudience(m); });
                        retValue.push.apply(retValue, __spreadArray([], __read(metadataItems), false));
                        oDataContextValue = result["@odata.context"];
                        _b.label = 4;
                    case 4:
                        i++;
                        return [3 /*break*/, 2];
                    case 5:
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [2 /*return*/, {
                                "@odata.context": oDataContextValue,
                                value: retValue
                            }];
                }
            });
        });
    };
    MetadataStoreService.prototype.getAllLegalMetadataItems = function () {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var url, perfEvent, rawResult, result;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        url = "".concat(this.crmUrl).concat(legalMetadataItems);
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getAllLegalMetadataItems-Perf-Ms");
                        return [4 /*yield*/, MetadataStoreService.fetchClient.fetchPost(url, "")];
                    case 1:
                        rawResult = _b.sent();
                        if (!rawResult.ok) {
                            throw new Error("Failed to get LegalMetadata items.");
                        }
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _b.sent();
                        return [2 /*return*/, {
                                "@odata.context": result["@odata.context"],
                                value: result.value.map(function (k) { return metadataItemCRMToMetadataItem(k); })
                            }];
                }
            });
        });
    };
    MetadataStoreService.prototype.searchMetadataItemsContaining = function (tokenInDisplayName) {
        throw new Error("Method not implemented.");
    };
    MetadataStoreService.prototype.preloadData = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/];
            });
        });
    };
    MetadataStoreService.prototype.getConversationVariables = function (request, allowStaleData) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var perfEvent, filter, query, response, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getConversationVariables-Perf-Ms");
                        filter = "<filter>" +
                            "<condition attribute=\"msdyn_proactive_engagement_config\" operator=\"eq\" value=\"".concat(request.proactiveEngagementConfigId, "\" />") +
                            "<condition attribute=\"statecode\" operator=\"eq\" value=\"0\"/>" +
                            "</filter>";
                        query = this.commonDataService.buildQueryString("msdyn_proactive_engagement_config_attribute", ["msdyn_keyword"], "msdyn_keyword", false, 1, 5000, filter);
                        return [4 /*yield*/, this.commonDataService.getRecords("msdyn_proactive_engagement_config_attributes", query)];
                    case 1:
                        response = _b.sent();
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [2 /*return*/, {
                                attributes: response.map(function (x) {
                                    return {
                                        keyword: x.msdyn_keyword,
                                        additionalProperties: {}
                                    };
                                }),
                                additionalProperties: {}
                            }];
                    case 2:
                        error_2 = _b.sent();
                        this.telemetryService.logError("Failed to retrieve conversation variables from msdyn_proactive_engagement_config_attribute", error_2);
                        throw error_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MetadataStoreService.prototype.getDispositionCodes = function (allowStaleData) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var perfEvent, filter, query, response, error_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        perfEvent = (_a = this.perfService) === null || _a === void 0 ? void 0 : _a.startScenario("Client-MetadataStore-getDispositionCodes-Perf-Ms");
                        filter = "<filter><condition attribute=\"statecode\" operator=\"eq\" value=\"0\"/></filter>";
                        query = this.commonDataService.buildQueryString("msdyn_ocdispositioncode", ["msdyn_name", "msdyn_dispositioncodevalue", "msdyn_ocdispositioncodeid"], "msdyn_dispositioncodevalue", false, 1, 5000, filter);
                        return [4 /*yield*/, this.commonDataService.getRecords("msdyn_ocdispositioncodes", query)];
                    case 1:
                        response = _b.sent();
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [2 /*return*/, {
                                dispositionCodes: response.map(function (x) {
                                    return {
                                        id: x.msdyn_ocdispositioncodeid,
                                        name: x.msdyn_name,
                                        code: x.msdyn_dispositioncodevalue
                                    };
                                })
                            }];
                    case 2:
                        error_3 = _b.sent();
                        this.telemetryService.logError("Failed to retrieve disposition codes from msdyn_ocdispositioncode", error_3);
                        throw error_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    MetadataStoreService.prototype.getDateFormats = function (_a) {
        var _b;
        var dateOnly = _a.dateOnly, timeZoneId = _a.timeZoneId, cultureName = _a.cultureName, timezoneIndepentent = _a.timezoneIndepentent;
        return __awaiter(this, void 0, void 0, function () {
            var url, perfEvent, rawResult, result, parsedResult;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        url = "".concat(this.crmUrl).concat("/api/data/v9.1/msdynmkt_DateTimeFormatOptions");
                        perfEvent = (_b = this.perfService) === null || _b === void 0 ? void 0 : _b.startScenario("Client-MetadataStore-getDateFormats-Perf-Ms");
                        return [4 /*yield*/, MetadataStoreService.fetchClient.fetchPost(url, {
                                msdynmkt_DateTimeRequestTimeZoneId: timeZoneId,
                                msdynmkt_DateTimeRequestCultureName: cultureName,
                                msdynmkt_DateTimeRequestDateOnlyV2: dateOnly,
                                msdynmkt_DateTimeRequestTimezoneIndepentent: timezoneIndepentent
                            })];
                    case 1:
                        rawResult = _c.sent();
                        if (!rawResult.ok) {
                            throw new Error("Failed to get date format items.");
                        }
                        perfEvent === null || perfEvent === void 0 ? void 0 : perfEvent.complete();
                        return [4 /*yield*/, rawResult.json()];
                    case 2:
                        result = _c.sent();
                        parsedResult = JSON.parse(result.msdynmkt_DateTimeResponse);
                        return [2 /*return*/, parsedResult.results];
                }
            });
        });
    };
    MetadataStoreService.prototype.crmEventMetadataToBasicEventMetadata = function (miCRM) {
        var _a;
        var targetAudience = (((_a = miCRM.msdynmkt_supportedtargetentities) === null || _a === void 0 ? void 0 : _a.split(",").map(function (x) { var _a; return (_a = x === null || x === void 0 ? void 0 : x.trim) === null || _a === void 0 ? void 0 : _a.call(x); })) || [])
            .filter(function (x) { return x; })
            .map(function (x) { return ({ logicalName: x }); });
        return {
            sourceLogicalName: miCRM.msdynmkt_uniquename,
            sourceDisplayName: miCRM.msdynmkt_name,
            targetAudience: targetAudience,
            businessUnit: miCRM["_owningbusinessunit_value"]
        };
    };
    MetadataStoreService.prototype.fillCIForEmptyAudience = function (metadata) {
        if (!metadata.targetAudience || metadata.targetAudience.length === 0) {
            metadata.targetAudience = [{ logicalName: "msdynci_customerprofile" }];
        }
        return metadata;
    };
    MetadataStoreService.staticBindingEntitiesKey = "staticBindingEntities";
    MetadataStoreService.fetchClient = new FetchClient();
    return MetadataStoreService;
}(Service));
export { MetadataStoreService };
